class FeaturedSlider extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.featured-slider__track');
    this.thumb = this.querySelector('.featured-slider__progress-thumb');
    if (!this.track || !this.thumb) return;

    this.update = this.update.bind(this);
    this.track.addEventListener('scroll', this.update, { passive: true });

    // The track's real width isn't final at connect time (cards/images are
    // still laying out), so a one-off measurement here would freeze a wrong
    // thumb width. The observer re-measures whenever the track's content or
    // viewport size actually changes — covers image loads and window resizes.
    this.resizeObserver = new ResizeObserver(this.update);
    this.resizeObserver.observe(this.track);
    Array.from(this.track.children).forEach((child) => this.resizeObserver.observe(child));

    this.update();
  }

  disconnectedCallback() {
    if (this.resizeObserver) this.resizeObserver.disconnect();
  }

  update() {
    const track = this.track;
    const maxScroll = track.scrollWidth - track.clientWidth;
    const visibleRatio = Math.min(1, track.clientWidth / track.scrollWidth);
    const thumbWidthPercent = Math.max(10, visibleRatio * 100);
    const scrollRatio = maxScroll > 0 ? track.scrollLeft / maxScroll : 0;
    const maxTranslatePercent = (100 - thumbWidthPercent) / thumbWidthPercent * 100;

    this.thumb.style.width = thumbWidthPercent + '%';
    this.thumb.style.transform = `translateX(${scrollRatio * maxTranslatePercent}%)`;
  }
}

customElements.define('featured-slider', FeaturedSlider);
